'use client'

import { Link } from '@algoacademy/design-system/web/actions/Link'
import { P3 } from '@algoacademy/design-system/web/typography/Paragraph'
import { useSearchParams } from 'next/navigation'

export function RegisterButton() {
  const searchParams = useSearchParams()
  const redirectTo = searchParams.get('redirectTo') ?? searchParams.get('callbackUrl') ?? '/app'

  return (
    <P3 className='text-center'>
      Chcesz założyć konto?{' '}
      <Link
        href={`/auth/register?redirectTo=${encodeURIComponent(redirectTo)}`}
        className='font-medium text-contentNavyAlgo hover:underline'
      >
        Zarejestruj się
      </Link>
    </P3>
  )
}
